// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VUzdgakr1ASQ9DyxjSAXBA\\=\\={margin-right:12px;width:fit-content}.vuXMbgccFrdwCWISqggE2A\\=\\={display:flex}", "",{"version":3,"sources":["webpack://./src/components/CopyBox/CopyBox.module.scss"],"names":[],"mappings":"AAAA,4BACE,iBAAA,CACA,iBAAA,CAGF,4BACE,YAAA","sourcesContent":[".iconContainer {\n  margin-right: 12px;\n  width: fit-content;\n}\n\n.button {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": "VUzdgakr1ASQ9DyxjSAXBA==",
	"button": "vuXMbgccFrdwCWISqggE2A=="
};
export default ___CSS_LOADER_EXPORT___;
